import { FC, ReactNode } from 'react';
import { styled } from '@mui/material/styles';
import { Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useDispatch,useSelector } from 'react-redux';
import { selectRefetChatCount,setGroupListUpdate } from '../../features/chat/chatSlice';
import Sidebar from './Sidebar';
import Header from './Header';
import request from '../../utils/request';
import SnackbarAlert from '../../pages/common/SnackbarAlert';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import { Box, Fab, Link } from '@mui/material';

// import { requestForToken, onMessageListener } from "../../config/firebase";



interface SidebarLayoutProps {
  children?: ReactNode;
}
const MainWrapper = styled(Box)(
  ({ theme }) => `
        flex: 1 1 auto;
        display: flex;
        height: 100%;
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            padding-left: ${theme.sidebar.width};
        }
`
);

const MainContent = styled(Box)(
  ({ theme }) => `
        margin-top: ${theme.header.height};
        flex: 1 1 auto;
        overflow: auto;
`
);

const SidebarLayout: FC<SidebarLayoutProps> = () => {
  const [chatMsgCnt,setChatMsgCnt]=useState<number>(0);
  const [showFab, setShowFab] = useState(true);
  const chatGroupCnt = useSelector(selectRefetChatCount);
  const [showSnackBarAlert, setShowSnackBarAlert] = useState({
    status: false,
    type: 'success',
    message: null
  });
  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  // eslint-disable-next-line
  // eslint-disable-next-line
  const [rolePermission, setRolePermission] = useState<any>();
  const dispatch = useDispatch();

  useEffect(() => {
    getAllPermissionList();
    getAuthUserTree();
    getChatMessageCount();
    if(window.location.protocol=='https:'||window.location.hostname=='localhost'){
      // requestForToken();
    }   
  },[])

  useEffect(()=>{
    getChatMessageCount();
  },[chatGroupCnt])

  

  const getAuthUserTree = () => {
    request({
      url: 'user/getUserTree',
      method: 'get'
    }).then(
      (response) => {
        if (response.status) {
          try{
            localStorage.setItem('userTree', JSON.stringify(response.data));
          }catch(error){

          }
         
          
        } else {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: 'Users fetch failed.'
          });
        }
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const getAllPermissionList = () => {
    request({
      url: 'role-permission/getAllPermissionList',
      method: 'post',
      data: {
        userId: 7
      }
    }).then(
      (response) => {
        localStorage.setItem('permissionDatas', JSON.stringify(response));
      },
      (error) => {
        console.log(error);
      }
    );
  };

  useEffect(() => {
    if (window.location.pathname === '/dashboards/messenger/') {
      setShowFab(false);
    } else {
      setShowFab(true);
    }
  });
  // eslint-disable-next-line
  const iconstyle = {
    margin: 0,
    top: 'auto',
    right: 20,
    bottom: 20,
    left: 'auto',
    position: 'fixed'
  };

  const getChatMessageCount = () => {

    request({
        url: 'chat/getChatUnreadMessageCount',
        method: 'post',
        data: {

        }
    }).then(
        (response) => {
          setChatMsgCnt(response?.data?.totalMessage);
          
        },
        (error) => {
            console.log(error);
        }
    );
}


// onMessageListener()
// .then((payload) => {
//    console.log('push message',payload)
//    let messageBody=JSON.parse(payload.notification.body);
//    dispatch(setGroupListUpdate({GroupListUpdate:(Math.random()*100)}))
//    getChatMessageCount();
// })
// .catch((err) => console.log("failed: ", err));

// useEffect(()=>{
//   window.addEventListener("message",handlerFunc);
//   return ()=> window.removeEventListener("message",handlerFunc);
// },[]);

// const handlerFunc=(e)=>{
//   console.log('handler function called');
//   getChatMessageCount();
// }



  return (
    <>
      <Sidebar />
      <MainWrapper>
        <Header />
        <SnackbarAlert
          showSnackBarAlert={showSnackBarAlert}
          handleSnackbarClose={handleSnackbarClose}
        />
        <MainContent>
          <Outlet />
          {showFab === false ? null : (
            <Link href="/dashboards/messenger">
              <div
                style={{
                  margin: 0,
                  top: 'auto',
                  right: 20,
                  bottom: 50,
                  left: 'auto',
                  position: 'fixed'
                }}
              >
                <Fab color="primary" aria-label="add">
                  <ChatBubbleIcon />
                
                 {chatMsgCnt>0 && <span className="msg-unread-count" style={{position: 'absolute', top: '-15px', right: '0px'}}>{chatMsgCnt}</span>} 
                </Fab>
              </div>
            </Link>
          )}
        </MainContent>
      </MainWrapper>
    </>
  );
};

export default SidebarLayout;
